export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            关于网红爆料
          </h2>
          <p className="text-xs text-foreground-400 mb-8">全网最专业的网红内幕实锤解说平台</p>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              网红爆料成立于2023年，是国内领先的网红行业深度内容聚合平台。
              我们聚焦网红经济全产业链，汇集全网最新、最全的网红黑料视频、内幕实锤解说及瓜视频大揭秘。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台内容涵盖直播带货翻车实录、MCN机构内幕调查、网红人设崩塌全记录、
              短视频造假手法揭露、网红圈情感纠纷追踪等多个垂直领域，
              以专业视角、严谨态度为吃瓜群众提供有深度、有温度的内容体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              目前平台日均活跃用户超百万，原创爆料视频累计超过3600部，
              已成长为中文互联网最具影响力的网红爆料内容平台之一。
              我们坚持每日更新、多方验证的原则，确保每一条信息的真实性与时效性。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-8 pt-4 border-t border-background-200">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500 font-heading">3600+</div>
                <div className="text-xs text-foreground-400 mt-1">原创视频</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500 font-heading">100万+</div>
                <div className="text-xs text-foreground-400 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-foreground-800 font-heading">2023</div>
                <div className="text-xs text-foreground-400 mt-1">成立年份</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}